import "./Footer.css";

function Footer() {
  return <footer className="footer">Built by Brandon Coish · 2026</footer>;
}

export default Footer;
